import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "text-white q-mr-md",
  style: {"font-size":"12px"}
}
const _hoisted_2 = { ref: "utcClockText" }
const _hoisted_3 = { class: "drawer-wrapper" }
const _hoisted_4 = { class: "drawer-panels" }
const _hoisted_5 = ["aria-valuemin", "aria-valuemax", "aria-valuenow"]
const _hoisted_6 = { class: "row q-pa-xs justify-start" }
const _hoisted_7 = { class: "tracking-worksheet-mobile-header row items-center no-wrap q-px-sm" }
const _hoisted_8 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserManagementLocal = _resolveComponent("UserManagementLocal")!
  const _component_PassageDialog = _resolveComponent("PassageDialog")!
  const _component_AddDevice = _resolveComponent("AddDevice")!
  const _component_RemoveDevice = _resolveComponent("RemoveDevice")!
  const _component_ChangePassword = _resolveComponent("ChangePassword")!
  const _component_QueueCommands = _resolveComponent("QueueCommands")!
  const _component_QueueIridiumCommands = _resolveComponent("QueueIridiumCommands")!
  const _component_DeviceHistory = _resolveComponent("DeviceHistory")!
  const _component_NotificationSettings = _resolveComponent("NotificationSettings")!
  const _component_RealTimeStream = _resolveComponent("RealTimeStream")!
  const _component_RealTimeOptions = _resolveComponent("RealTimeOptions")!
  const _component_PipelineSectionManager = _resolveComponent("PipelineSectionManager")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_header = _resolveComponent("q-header")!
  const _component_DeviceInfo = _resolveComponent("DeviceInfo")!
  const _component_DeviceTable = _resolveComponent("DeviceTable")!
  const _component_PigRunManager = _resolveComponent("PigRunManager")!
  const _component_ReportManager = _resolveComponent("ReportManager")!
  const _component_DownloadManager = _resolveComponent("DownloadManager")!
  const _component_BroadcastCommands = _resolveComponent("BroadcastCommands")!
  const _component_StreamManager = _resolveComponent("StreamManager")!
  const _component_GroupChat = _resolveComponent("GroupChat")!
  const _component_q_drawer = _resolveComponent("q-drawer")!
  const _component_PigRunTrackingWorksheet = _resolveComponent("PigRunTrackingWorksheet")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_Map = _resolveComponent("Map")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_PigProgressCard = _resolveComponent("PigProgressCard")!
  const _component_q_layout = _resolveComponent("q-layout")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_layout, { view: "hHh lpr fFf" }, {
    default: _withCtx(() => [
      _createVNode(_component_UserManagementLocal),
      _createVNode(_component_PassageDialog),
      _createVNode(_component_AddDevice),
      _createVNode(_component_RemoveDevice),
      _createVNode(_component_ChangePassword),
      _createVNode(_component_QueueCommands),
      _createVNode(_component_QueueIridiumCommands),
      _createVNode(_component_DeviceHistory),
      _createVNode(_component_NotificationSettings),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.openStreamUids, (uid) => {
        return (_openBlock(), _createBlock(_component_RealTimeStream, {
          key: uid,
          "stream-uid": uid,
          "is-active": uid === _ctx.activeStreamUid,
          onStreamClosed: _ctx.onStreamClosed
        }, null, 8, ["stream-uid", "is-active", "onStreamClosed"]))
      }), 128)),
      _createVNode(_component_RealTimeOptions),
      _createVNode(_component_PipelineSectionManager, {
        modelValue: _ctx.managePipelineSectionDialog,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.managePipelineSectionDialog) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_q_header, {
        elevated: "",
        class: "basic",
        style: {"background-color":"#24337a"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_toolbar, { class: "bg-blue-brand text-white" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                flat: "",
                dense: "",
                round: "",
                icon: "menu",
                class: "lt-md q-mr-sm",
                "aria-label": "Toggle menu",
                onClick: _ctx.openDrawer
              }, null, 8, ["onClick"]),
              _cache[24] || (_cache[24] = _createElementVNode("img", {
                src: "PropipeNorthAmericaLogo-WhiteRed.png",
                title: "ProPipe North America",
                style: {"height":"40px"}
              }, null, -1)),
              _cache[25] || (_cache[25] = _createElementVNode("div", {
                class: "gt-sm q-ml-md text-red",
                style: {"font-size":"12px"}
              }, " SMS text messaging alerts now require opt-in permission. Sign up through the user menu. ", -1)),
              _createVNode(_component_q_space),
              _createElementVNode("span", _hoisted_1, [
                _createElementVNode("span", _hoisted_2, null, 512),
                _createVNode(_component_q_tooltip, {
                  anchor: "bottom middle",
                  self: "top middle",
                  offset: [0, 8],
                  "max-width": "280px"
                }, {
                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createTextVNode(" This is your current local time converted to UTC (Coordinated Universal Time), the global standard time zone used to keep all systems synchronized regardless of your location. ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              (_ctx.isWorksheetDrawerMobile)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 0,
                    flat: "",
                    dense: "",
                    round: "",
                    icon: _ctx.worksheetMobileSheetOpen ? 'close' : 'table_chart',
                    "aria-label": 
            _ctx.worksheetMobileSheetOpen ? 'Close tracksheet' : 'Open tracksheet'
          ,
                    "aria-expanded": _ctx.worksheetMobileSheetOpen,
                    onClick: _ctx.toggleMobileWorksheetSheet
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.worksheetMobileSheetOpen ? 'Close tracksheet' : 'Open tracksheet'), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["icon", "aria-label", "aria-expanded", "onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_q_btn, {
                round: "",
                flat: "",
                icon: "more_vert"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_list, { style: {"min-width":"200px"} }, {
                        default: _withCtx(() => [
                          (_ctx.userHasAnyRole('admin', 'superadmin'))
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 0,
                                clickable: "",
                                onClick: _ctx.onUserManager
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                      _createTextVNode("User Manager", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onClick"])), [
                                [_directive_close_popup]
                              ])
                            : _createCommentVNode("", true),
                          (_ctx.userHasAnyRole('admin', 'superadmin'))
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 1,
                                clickable: "",
                                onClick: _ctx.onStreamManagerClick
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                      _createTextVNode("Stream Manager", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onClick"])), [
                                [_directive_close_popup]
                              ])
                            : _createCommentVNode("", true),
                          (_ctx.userHasAnyRole('superadmin'))
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 2,
                                clickable: "",
                                onClick: _ctx.onGroupAssignment
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                      _createTextVNode("Group Assignment", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onClick"])), [
                                [_directive_close_popup]
                              ])
                            : _createCommentVNode("", true),
                          (
                  _ctx.userHasAnyRole('metrics') &&
                  _ctx.userHasAnyRole('admin', 'superadmin')
                )
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 3,
                                clickable: "",
                                onClick: _ctx.onSystemMetrics
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                      _createTextVNode("System Metrics", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onClick"])), [
                                [_directive_close_popup]
                              ])
                            : _createCommentVNode("", true),
                          (_ctx.userHasAnyRole('moderator'))
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 4,
                                clickable: "",
                                to: { name: 'moderation' }
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                      _createTextVNode("Moderation", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })), [
                                [_directive_close_popup]
                              ])
                            : _createCommentVNode("", true),
                          (_ctx.userHasAnyRole('admin') && !_ctx.userHasAnyRole('superadmin'))
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 5,
                                clickable: "",
                                onClick: _ctx.onPipelineSectionManager
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                      _createTextVNode("Pipeline Manager", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onClick"])), [
                                [_directive_close_popup]
                              ])
                            : _createCommentVNode("", true),
                          (_ctx.userHasAnyRole('admin') && !_ctx.userHasAnyRole('superadmin'))
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 6,
                                clickable: "",
                                onClick: _ctx.onPigRunManagerWizard
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                      _createTextVNode("Pig Run Manager", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onClick"])), [
                                [_directive_close_popup]
                              ])
                            : _createCommentVNode("", true),
                          (_ctx.userHasAnyRole('admin'))
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 7,
                                clickable: "",
                                onClick: _ctx.onDownloadManagerClick
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                      _createTextVNode("Download Manager", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onClick"])), [
                                [_directive_close_popup]
                              ])
                            : _createCommentVNode("", true),
                          (_ctx.userHasAnyRole('admin'))
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 8,
                                clickable: "",
                                onClick: _ctx.onReportManagerClick
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                      _createTextVNode("Report Manager", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onClick"])), [
                                [_directive_close_popup]
                              ])
                            : _createCommentVNode("", true),
                          (_ctx.userHasAnyRole('admin'))
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 9,
                                clickable: "",
                                onClick: _ctx.onBroadcastCommandsClick
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                      _createTextVNode("Broadcast Commands", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onClick"])), [
                                [_directive_close_popup]
                              ])
                            : _createCommentVNode("", true),
                          _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                            clickable: "",
                            onClick: _ctx.onNotificationSettings
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                  _createTextVNode("Notifications / SMS Opt-in", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["onClick"])), [
                            [_directive_close_popup]
                          ]),
                          _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                            clickable: "",
                            onClick: _ctx.onServiceStatus
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                  _createTextVNode("Service Status", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["onClick"])), [
                            [_directive_close_popup]
                          ]),
                          _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                            clickable: "",
                            role: "link",
                            to: { name: 'supportLibrary' }
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                  _createTextVNode("Technical Support", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })), [
                            [_directive_close_popup]
                          ]),
                          _createVNode(_component_q_separator),
                          _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                            clickable: "",
                            onClick: _ctx.onChangePassword
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                  _createTextVNode("Change Password", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["onClick"])), [
                            [_directive_close_popup]
                          ]),
                          _createVNode(_component_q_separator),
                          _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                            clickable: "",
                            onClick: _ctx.onLogout
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                  _createTextVNode("Logout", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["onClick"])), [
                            [_directive_close_popup]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_q_drawer, {
        modelValue: _ctx.leftDrawerOpen,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.leftDrawerOpen) = $event)),
        "show-if-above": "",
        bordered: "",
        width: _ctx.drawerMini ? 40 : _ctx.drawerWidth,
        "content-class": "bg-grey-2",
        onHide: _ctx.drawerToggle,
        onShow: _ctx.drawerToggle
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("div", {
              class: _normalizeClass(["row q-pa-xs", _ctx.drawerMini ? 'justify-center' : 'justify-end'])
            }, [
              _createVNode(_component_q_btn, {
                flat: "",
                dense: "",
                round: "",
                icon: _ctx.drawerMini ? 'chevron_right' : 'chevron_left',
                "aria-label": _ctx.drawerMini ? 'Expand drawer' : 'Collapse drawer',
                onClick: _ctx.toggleDrawer
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_tooltip, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.drawerMini ? 'Expand menu' : 'Collapse menu'), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["icon", "aria-label", "onClick"])
            ], 2), [
              [_vShow, !_ctx.chatExpanded]
            ]),
            (!_ctx.drawerMini)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _withDirectives(_createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_DeviceInfo),
                    _createVNode(_component_DeviceTable),
                    _createVNode(_component_PigRunManager),
                    _createVNode(_component_ReportManager),
                    _createVNode(_component_DownloadManager),
                    _createVNode(_component_BroadcastCommands),
                    _createVNode(_component_StreamManager)
                  ], 512), [
                    [_vShow, !_ctx.chatExpanded]
                  ]),
                  (_ctx.userHasAnyRole('admin', 'superadmin'))
                    ? (_openBlock(), _createBlock(_component_GroupChat, {
                        key: 0,
                        "onUpdate:expanded": _cache[1] || (_cache[1] = ($event: any) => (_ctx.chatExpanded = $event))
                      }))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "width", "onHide", "onShow"]),
      (!_ctx.isWorksheetDrawerMobile)
        ? (_openBlock(), _createBlock(_component_q_drawer, {
            key: 0,
            modelValue: _ctx.worksheetDrawerOpen,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.worksheetDrawerOpen) = $event)),
            side: "right",
            behavior: "desktop",
            bordered: "",
            width: _ctx.worksheetDrawerWidth,
            "content-class": "bg-grey-1 tracking-worksheet-drawer",
            onHide: _ctx.onTrackingWorksheetDrawerHide
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(["tracking-worksheet-resize-handle", {
          'tracking-worksheet-resize-handle--active':
            _ctx.worksheetDrawerResize !== null,
        }]),
                role: "separator",
                "aria-orientation": "vertical",
                "aria-label": "Resize tracksheet",
                "aria-valuemin": _ctx.worksheetDrawerMinimumWidth,
                "aria-valuemax": _ctx.worksheetDrawerMaximumWidth,
                "aria-valuenow": _ctx.worksheetDrawerWidth,
                tabindex: "0",
                onPointerdown: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.startWorksheetDrawerResize && _ctx.startWorksheetDrawerResize(...args))),
                onDblclick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.resetWorksheetDrawerWidth && _ctx.resetWorksheetDrawerWidth(...args))),
                onKeydown: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onWorksheetDrawerResizeKeydown && _ctx.onWorksheetDrawerResizeKeydown(...args)))
              }, [
                _createVNode(_component_q_tooltip, null, {
                  default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                    _createTextVNode("Drag to resize tracksheet. Double-click to reset.", -1)
                  ]))]),
                  _: 1
                })
              ], 42, _hoisted_5),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_q_btn, {
                  flat: "",
                  dense: "",
                  round: "",
                  icon: "chevron_right",
                  "aria-label": "Collapse tracksheet",
                  onClick: _ctx.closeWorksheetDrawer
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_tooltip, null, {
                      default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                        _createTextVNode("Collapse tracksheet", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              (_ctx.worksheetContentMounted)
                ? (_openBlock(), _createBlock(_component_PigRunTrackingWorksheet, {
                    key: 0,
                    entry: _ctx.selectedPigRunEntry,
                    "completed-pig-run-id": _ctx.selectedCompletedPigRunId,
                    onShowMarkerOnMap: _ctx.onShowMarkerOnMap
                  }, null, 8, ["entry", "completed-pig-run-id", "onShowMarkerOnMap"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue", "width", "onHide"]))
        : _createCommentVNode("", true),
      (_ctx.isWorksheetDrawerMobile)
        ? (_openBlock(), _createBlock(_component_q_dialog, {
            key: 1,
            modelValue: _ctx.worksheetMobileSheetOpen,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.worksheetMobileSheetOpen) = $event)),
            maximized: "",
            "transition-show": "slide-up",
            "transition-hide": "slide-down",
            onHide: _ctx.onTrackingWorksheetMobileSheetHide
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card, { class: "tracking-worksheet-sheet bg-grey-1" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _cache[29] || (_cache[29] = _createElementVNode("div", { class: "text-subtitle2 text-weight-medium text-grey-9" }, " Tracksheet ", -1)),
                    _createVNode(_component_q_space),
                    _createVNode(_component_q_btn, {
                      flat: "",
                      dense: "",
                      round: "",
                      icon: "close",
                      "aria-label": "Close tracksheet",
                      onClick: _ctx.closeMobileWorksheetSheet
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_tooltip, null, {
                          default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                            _createTextVNode("Close tracksheet", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  (_ctx.worksheetContentMounted)
                    ? (_openBlock(), _createBlock(_component_PigRunTrackingWorksheet, {
                        key: 0,
                        class: "tracking-worksheet-mobile-content",
                        entry: _ctx.selectedPigRunEntry,
                        "completed-pig-run-id": _ctx.selectedCompletedPigRunId,
                        onShowMarkerOnMap: _ctx.onShowMarkerOnMap
                      }, null, 8, ["entry", "completed-pig-run-id", "onShowMarkerOnMap"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "onHide"]))
        : _createCommentVNode("", true),
      _createVNode(_component_q_page_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_Map),
          (!_ctx.isWorksheetDrawerMobile)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "tracking-worksheet-toggle-overlay",
                style: _normalizeStyle(_ctx.trackingWorksheetToggleStyle)
              }, [
                _createVNode(_component_q_btn, {
                  unelevated: "",
                  dense: "",
                  "no-caps": "",
                  icon: "table_chart",
                  label: "Tracksheet",
                  class: "tracking-worksheet-toggle",
                  color: _ctx.isWorksheetDrawerOpen ? 'primary' : 'white',
                  "text-color": _ctx.isWorksheetDrawerOpen ? 'white' : 'grey-8',
                  "aria-label": 
            _ctx.isWorksheetDrawerOpen ? 'Close tracksheet' : 'Open tracksheet'
          ,
                  "aria-pressed": _ctx.isWorksheetDrawerOpen,
                  onClick: _ctx.toggleWorksheetDrawer
                }, null, 8, ["color", "text-color", "aria-label", "aria-pressed", "onClick"])
              ], 4))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_ctx.devicesReady && _ctx.selectedPigRun)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_openBlock(), _createBlock(_component_PigProgressCard, {
              key: _ctx.selectedPigRun.pigRunId,
              "pig-run": _ctx.selectedPigRun,
              position: 0
            }, null, 8, ["pig-run"]))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}